export default {
    CREATE_BOARD: () => '/board/createBoard',
    GETALLBOARD: () => '/board/getAllBoard',
    SELECTED_BOARD: (id) => `/boardList/getBoardListByboardId/${id}`,
    SEQUENCE: (id) => `/boardList/updateBoardListSequence/${id}`,
    DELETE_BOARD: (id) => `/board/deleteBoard/${id}`,
    GET_BOARD_LIST: () => `/board/getBoardWithBoardList`,
    GET_BOARD_LIST_BY_ID: (id) => `/board/getBoardBy/${id}`,
};
